export default class QueuePolicy {
    static browse(user) {
        return user.hasPermissionTo('browse:queues');
    }

    /* eslint-disable-next-line no-unused-vars */
    static read(user, queue) {
        return user.hasPermissionTo('read:queues');
    }

    static edit(user, queue) {
        return queue.deleted_at === null
            && user.hasPermissionTo('edit:queues');
    }

    static add(user) {
        return user.hasPermissionTo('add:queues');
    }

    static destroy(user, queue) {
        return queue.deleted_at === null
            && user.hasPermissionTo('delete:queues');
    }

    static restore(user, queue) {
        return queue.deleted_at !== null
            && user.hasPermissionTo('delete:queues');
    }

    /* eslint-disable-next-line no-unused-vars */
    static sort(user, queue) {
        return user.hasPermissionTo('edit:queues');
    }

    static updateSortIndex(user, queue, destination) {
        if (!QueuePolicy.sort(user, queue)) {
            return false;
        }

        if (!destination) {
            return false;
        }

        return queue.sort_index !== Number(destination);
    }

    static reorderPublication(user, queue) {
        return user.hasPermissionTo('reorder:publication-in-queue');
    }
}
